import { Extension } from '@tiptap/core'

const LIST_ITEM_TYPES = ['taskItem', 'listItem']

/**
 * Fixes Tiptap/ProseMirror bug where removing the last character in a list item
 * creates a new item instead of removing it.
 * See: https://github.com/ueberdosis/tiptap/issues/3128
 */
export const ListItemBackspace = Extension.create({
  name: 'listItemBackspace',

  addKeyboardShortcuts() {
    return {
      Backspace: () => {
        const { selection } = this.editor.state
        const { $from } = selection
        const parent = $from.parent
        const grandparent = $from.node(-1)
        const grandparentType = grandparent?.type.name

        if (
          parent.type.name !== 'paragraph' ||
          !grandparentType ||
          !LIST_ITEM_TYPES.includes(grandparentType)
        ) {
          return false
        }

        // When there's only one character left and the cursor is
        // after it, delete the character AND lift the list item.
        if (parent.content.size === 1 && $from.parentOffset === 1) {
          return this.editor
            .chain()
            .deleteRange({ from: $from.pos - 1, to: $from.pos })
            .liftListItem(grandparentType)
            .run()
        }

        return false
      },
    }
  },
})
